import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks, companyDetails } from '../lib/mock';
import { Button } from './ui/button';
import { Menu, X, Phone } from 'lucide-react';
import { Sheet, SheetContent, SheetTrigger } from './ui/sheet';

export default function Navbar() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed w-full top-0 z-50 glass-nav transition-all duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center text-white font-bold text-xl">
              BG
            </div>
            <div className="flex flex-col">
              <span className="font-bold text-xl tracking-tight text-primary leading-none">
                BG TECHNO CHEM
              </span>
              <span className="uppercase !text-xs text-muted-foreground">
                Water & Industrial Solutions
              </span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) =>
            <Link
              key={link.path}
              to={link.path}
              className={`text-sm font-medium transition-colors hover:text-primary ${
              isActive(link.path) ? 'text-primary font-bold' : 'text-slate-600'}`
              }>

                {link.name}
              </Link>
            )}
            <Link to="/contact">
              <Button className="bg-primary hover:bg-brand-darkBlue text-white gap-2 shadow-lg hover:shadow-xl transition-all">
                <Phone size={16} /> Get a Quote
              </Button>
            </Link>
          </div>

          {/* Mobile Menu */}
          <div className="md:hidden">
            <Sheet open={isOpen} onOpenChange={setIsOpen}>
              <SheetTrigger asChild>
                <Button variant="ghost" size="icon">
                  <Menu className="h-6 w-6" />
                </Button>
              </SheetTrigger>
              <SheetContent side="right" className="w-[300px] sm:w-[400px]">
                <div className="flex flex-col gap-6 mt-10">
                  {navLinks.map((link) =>
                  <Link
                    key={link.path}
                    to={link.path}
                    onClick={() => setIsOpen(false)}
                    className="text-lg font-medium hover:text-primary">

                      {link.name}
                    </Link>
                  )}
                  <div className="mt-4 pt-4 border-t">
                     <p className="text-sm text-muted-foreground mb-2">Contact Us</p>
                     <p className="font-semibold text-primary">{companyDetails.phone}</p>
                     <p className="text-sm">{companyDetails.email}</p>
                  </div>
                </div>
              </SheetContent>
            </Sheet>
          </div>
        </div>
      </div>
    </nav>);

}